
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.0402 4.89334C15.6747 5.07016 15.5217 5.50997 15.6985 5.87529C16.1816 6.87321 16.4265 7.94887 16.4265 9.07353C16.4265 13.1279 13.1279 16.4265 9.07353 16.4265C5.01918 16.4265 1.72059 13.1279 1.72059 9.07353C1.72059 5.01918 5.01918 1.72059 9.07353 1.72059C10.7536 1.72059 12.3319 2.26919 13.6382 3.30696C13.9551 3.5599 14.4184 3.50694 14.6714 3.18902C14.9243 2.87128 14.8713 2.40849 14.5532 2.15591C13.0067 0.926772 11.0606 0.25 9.07353 0.25C4.20849 0.25 0.25 4.20849 0.25 9.07353C0.25 13.9386 4.20849 17.8971 9.07353 17.8971C13.9386 17.8971 17.8971 13.9386 17.8971 9.07353C17.8971 7.72537 17.6027 6.4334 17.0221 5.23496C16.8456 4.86875 16.4044 4.71616 16.0402 4.89334Z","fill":"#9C9FAA"}}),_c('path',{attrs:{"d":"M9.07353 3.19118C8.66764 3.19118 8.33823 3.52059 8.33823 3.92647V9.07353C8.33823 9.47941 8.66764 9.80882 9.07353 9.80882H12.75C13.1559 9.80882 13.4853 9.47941 13.4853 9.07353C13.4853 8.66765 13.1559 8.33824 12.75 8.33824H9.80882V3.92647C9.80882 3.52059 9.47941 3.19118 9.07353 3.19118Z","fill":"#9C9FAA"}})])
          )
        }
      }
    